"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.create.title': '创建教程',
    'tutorial.create.button': '创建教程',
};
